import React from 'react';
import { noop } from 'lodash';

type TabsProps = {
  activeTab: number;
  selectTab: (idx: number) => void;
};

export const TabsContext = React.createContext<TabsProps>({
  activeTab: 0,
  selectTab: noop
});

export const useTabsContext = (): TabsProps => React.useContext(TabsContext);
